<template>
	<div v-if="loading">
		Refreshing. Please, wait a moment...
	</div>
	<div v-else-if="!data.warehouse.sales_order">
		This order has not been pushed to warehouse yet,
		or it has been pushed with another provider than the Test Warehouse.
	</div>
	<div v-else>

		<h3 style="margin: 0">Warehouse</h3>
		<p>
			Welcome inside <strong>Test Warehouse</strong>. The best parcel company
			north of all the other good warehouses.
		</p>

		<div>
			<strong>Released at:</strong>
			{{ data.warehouse.sales_order.released_at }}
		</div>

		<div>
			<strong>Shipped at:</strong>
			{{ data.warehouse.sales_order.shipped_at }}
		</div>

		<div>
			<strong>Return received at:</strong>
			{{ data.warehouse.sales_order.return_received_at }}
		</div>

		<button
			class="small-margin-top small"
			:disabled="saving"
			v-on:click="shipped">Shipped</button>

		<h2>Provided order lines</h2>
		<div
			class="flex"
			style="align-items: center; margin-bottom: 10px;"
			v-for="line in data.warehouse.sales_order_lines">
			<div
				style="width: 80px">
				<img
					style="max-width: 60px; max-height: 60px;"
					:src="line.product.thumbnail"
					/>
			</div>
			<div style="width: 300px;">
				{{ line.warehouse_status.sku }}
			</div>
			<div style="width: 80px;">
				{{ line.warehouse_status.qty }}
			</div>
			<div>
				<input
					type="number"
					v-model="line.warehouse_status.qty_to_return"
					style="width: 80px;"
					:max="line.warehouse_status.qty"
					:min="0"
					/>
			</div>
		</div>

		<div class="margin-top">
			<button
				class="small small-margin-right"
				:disabled="saving"
				v-on:click="update">Save</button>

			<button
				class="small"
				:disabled="saving"
				v-on:click="returnReceived">Return received</button>
		</div>

	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    id: {
      required: true
    },
    data: {
      required: true
    },
    loading: {
      required: true,
      type: Boolean
    }
  },
  data: () => ({
    saving: false
  }),
  methods: {
    update () {
      Vue.$api.patch(
        '/testing/order/' + this.id + '/warehouse',
        this.data.warehouse,
        {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: () => this.$emit('updated')
        })
    },
    shipped () {
      Vue.$api.post(
        '/testing/order/' + this.id + '/warehouse/shipped',
        {},
        {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: () => this.$emit('updated')
        })
    },
    returnReceived () {
      Vue.$api.post(
        '/testing/order/' + this.id + '/warehouse/return-received',
        {},
        {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: () => this.$emit('updated')
        })
    }
  }
}
</script>

<style lang="less">
	.shipping-item {
		border-bottom: 1px solid #ccc;
		.shipping-item-title {
			height: 46px;
		padding-bottom: 10px;
		padding-top: 10px;
			.shipping-dot {
				position: relative;
				width: 20px;
				height: 20px;
				border-radius: 50%;
				background: #fff;
				cursor: pointer;
				border: 1px solid #888;
				&::after {
					position: absolute;
					content: "";
					top: 3px;
					bottom: 3px;
					left: 3px;
					right: 3px;
					background: #fff;
					border-radius: 50%;
				}
			}
			.shipping-icon {
				margin-right: 15px;
				.svg-icon, svg {
					width: 24px !important;
					height: 24px !important;
				}
				svg {
					fill: #aaa;
				}
			}
			&.active {
				.shipping-dot::after {
					background: #032A8A;
				}
				.shipping-icon svg {
					fill: #032A8A;
				}
			}
			&.hovered {
				.shipping-dot::after {
					background: #9237FF;
				}
				.shipping-icon svg {
					fill: #9237FF;
				}
			}
		}
	}
</style>
